import {Component, effect, EventEmitter, Input, Output, Signal, signal} from '@angular/core';
import {Utils} from "../../../../shared/utils";
import {MatchesService} from "../../../../services/matches.service";
import {NbButtonModule, NbDialogService, NbIconModule, NbPopoverModule, NbToastrService} from "@nebular/theme";
import {ReportGameFormComponent} from "./report-game-form/report-game-form.component";
import {TeamsService} from "../../../../services/teams.service";
import {StorageService} from "../../../../services/storage.service";
import {ScreenshotsGalleryComponent} from "../../../admin/games/screenshots-gallery/screenshots-gallery.component";
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-report',
  standalone: true,
  imports: [
    TranslateModule,
    NbButtonModule,
    NbIconModule,
    NbPopoverModule
  ],
  templateUrl: './report.component.html',
  styleUrl: './report.component.scss'
})
export class ReportComponent {
  protected user: any;
  selectedDivisionId: string | undefined;
  selectedGroupId: string | undefined;

  loading = signal<boolean>(false);
  reportGame = signal<any>({});

  @Input() triggerTabsRefresh!: Signal<string>;
  @Input() currentUserTeamIds = signal<string[]>([]);
  @Input() selectedDivisionIdSignal = signal<string>('');
  @Input() selectedGroupIdSignal = signal<string>('A');
  @Output() onMatchUpdate = new EventEmitter<any>();

  constructor(public utils: Utils, private storageService: StorageService, protected teamsService: TeamsService, private matchesService: MatchesService, private dialogService: NbDialogService) {
    effect(() => {
      const refreshTriggeredBy = this.triggerTabsRefresh();
      if (refreshTriggeredBy == 'by_report') {
        return;
      }
      this.user = this.storageService.user();
      setTimeout(() => this.search());
    });
  }

  search() {
    this.matchesService.reportGame().subscribe((teams: any) => {
      this.reportGame.set(teams);
      this.loading.set(false);
    });
  }

  openReportGameForm(match: any) {
    this.dialogService.open(ReportGameFormComponent, {
      context: {
        match: match,
      },
    }).onClose.subscribe(() => {
      this.search();
      this.onMatchUpdate.emit('by_report');
    });
  }

  openScreenshotsGallery(match: any) {
    this.dialogService.open(ScreenshotsGalleryComponent, {
      dialogClass: 'popup',
      context: {
        match: match
      },
    });
  }

  protected getProfileSrc(match: any): string {
    return this.utils.teamImageUrl(null,
      this.teamsService.isUserTeam(this.currentUserTeamIds, match.team_id_1) ? match.team_id_1 : match.team_id_2,
      this.teamsService.isUserTeam(this.currentUserTeamIds, match.team_id_1) ? match.team_1_has_profile_picture : match.team_2_has_profile_picture
    );
  }
}
